// PRD 07 §4 데이터 정의 — single Grade badge per row, drawn with the SHARED `.grade` token:
//   G1 (예방적 관리)   → 초록 --grade-g1
//   G2 (자가처치)      → 노랑 --grade-g2
//   G3 (의료진 상담)   → 주황 --grade-g3
// "공유 .grade 토큰 — 단계 1(초록), 단계 2(노랑), 단계 3(주황). PRO항목설계와 동일".
//
// SHCT-841 — this used to hard-code a pale bg / colored text pair (blue/yellow/red) copied
// from the pre-v1.7 prototype. v1.7 (2026.06.11) corrected the badge colours to the shared
// token, and the prototype's gradeBadge() now emits `<span class="grade grade-gN">` — a solid
// token background with white text. PRD 07 §2.2 #7/#13 still print the old "파랑/빨강"
// wording; that is doc drift against §4 + the prototype, and is reported on the ticket.
//
// SHCT-636 — the badge TEXT is the display label ("단계 1/2/3"), not the raw code.
// The G1/G2/G3 identifier still keys the token and stays in the data (공통 시스템정의
// §3.3.3 "코드 식별자 보존", PRD 07 §2.2 "Grade 배지: 단계 1 / 단계 2 / 단계 3").

import { useTranslation } from 'react-i18next';

import type { GuidelineGrade } from '../types/management-guidelines.types';

interface GradeBadgeProps {
  grade: GuidelineGrade;
}

export function GradeBadge({ grade }: GradeBadgeProps) {
  const { t } = useTranslation('management-guidelines');
  return (
    <span className={`grade grade-${grade.toLowerCase()}`} data-grade={grade}>
      {t(`gradeLabels.${grade}`)}
    </span>
  );
}
